import { render } from "./PersonalSavingsVerification.vue?vue&type=template&id=c93fd824"
import script from "./PersonalSavingsVerification.vue?vue&type=script&lang=js"
export * from "./PersonalSavingsVerification.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__